export default class Validators {
    static validateNumberField(value: string): boolean {
        if (value == null || value === "") {
            return false
        }

        const numberRegExp: RegExp = /^[0-9]*$/gm
        if (!numberRegExp.test(value)) {
            return false
        } else {
            return true
        }
    }

    static validateFloatNumberField(value: string): boolean {
        if (value == null || value === "") {
            return false
        }

        const numberRegExp: RegExp = /^\d*\.?\d*$/gm
        if (!numberRegExp.test(value)) {
            return false
        } else {
            return true
        }
    }

    static validateDateField(value: string): boolean {
        if (isNaN(Date.parse(value))) {
            return false
        } else {
            return true
        }
    }
}
